import React from 'react';
import { Briefcase, Award } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { experience, certifications } from '../mock';

const Experience = () => {
  return (
    <section className="min-h-screen bg-[#0a0a0a] py-32 px-6">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-5xl md:text-6xl font-bold text-center text-white mb-8 drop-shadow-[0_0_20px_rgba(59,130,246,0.3)]">
          Experience & Certifications
        </h2>
        <p className="text-xl text-gray-400 text-center mb-20">
          My professional journey
        </p>

        {/* Work Experience */}
        <Card className="bg-gradient-to-br from-[#0f0f1a] to-[#1a1a2e] border-blue-500/30 p-10 mb-12 hover:shadow-[0_0_40px_rgba(59,130,246,0.2)] transition-all duration-500 backdrop-blur-sm">
          <div className="flex items-start gap-6">
            <div className="p-4 bg-gradient-to-br from-blue-600/20 to-cyan-600/20 rounded-xl shadow-[0_0_15px_rgba(59,130,246,0.2)]">
              <Briefcase className="w-8 h-8 text-blue-400" />
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h3 className="text-3xl font-bold text-white mb-2">
                    {experience.role}
                  </h3>
                  <p className="text-xl text-blue-400 font-semibold">
                    {experience.company}
                  </p>
                </div>
                <Badge className="bg-cyan-600/20 text-cyan-300 border-cyan-500/30">
                  {experience.period}
                </Badge>
              </div>
              <p className="text-lg text-gray-400 italic mb-6">
                {experience.description}
              </p>
              <ul className="space-y-3">
                {experience.responsibilities.map((resp, index) => (
                  <li key={index} className="flex items-start gap-3 text-gray-400">
                    <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mt-2 flex-shrink-0 shadow-[0_0_5px_rgba(59,130,246,0.5)]"></span>
                    <span>{resp}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Card>

        {/* Certifications */}
        <div className="space-y-6">
          <h3 className="text-3xl font-bold text-white mb-6 flex items-center gap-3">
            <Award className="w-8 h-8 text-cyan-400" />
            Certifications
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            {certifications.map((cert) => (
              <Card
                key={cert.id}
                className="bg-[#0f0f1a] border-gray-800 hover:border-cyan-500/50 p-6 transition-all duration-300 hover:scale-105 hover:shadow-[0_0_25px_rgba(6,182,212,0.2)] backdrop-blur-sm"
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-cyan-600/20 rounded-lg shadow-[0_0_10px_rgba(6,182,212,0.2)]">
                    <Award className="w-6 h-6 text-cyan-400" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">
                      {cert.title}
                    </h4>
                    <p className="text-gray-400 text-sm mb-2">{cert.issuer}</p>
                    {cert.description && (
                      <p className="text-gray-500 text-xs">{cert.description}</p>
                    )}
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;